export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    leftArrowBackground: p => p.accentWhite,
    rightArrowBackground: p => p.tertiaryDark,
    socialColor: p => p.accentWhite
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    background: p => p.tertiaryLight,
    leftArrowBackground: p => p.tertiaryDark,
    rightArrowBackground: p => p.accentWhite,
    socialColor: p => p.tertiaryDark
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    leftArrowBackground: p => p.tertiaryDark,
    rightArrowBackground: p => p.accentWhite,
    socialColor: p => p.tertiaryDark
  }
}
